import {
  FILTER_KEYS,
  parseNumberFilter,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
} from '@/utils/filters';
import { SURVEY_SUBMISSION_REPORTING_TO_KEY } from '../constants/survey.constants';
import type { SurveySubmissionFilters } from '../types/survey.types';

type FilterValues = Record<string, string>;

type SurveySubmissionPanelFilters = Omit<SurveySubmissionFilters, 'search'>;

export function toSurveySubmissionFilterValues(search: SurveySubmissionPanelFilters): FilterValues {
  return {
    [FILTER_KEYS.departmentId]: toFilterText(search.departmentId),
    ...toGeoFilterValues(search),
    [SURVEY_SUBMISSION_REPORTING_TO_KEY]: toFilterText(search.reportingToId),
  };
}

export function toSurveySubmissionFilterSearch(values: FilterValues): SurveySubmissionPanelFilters {
  return {
    departmentId: parseNumberFilter(values[FILTER_KEYS.departmentId]),
    ...toGeoSearch(values),
    reportingToId: parseNumberFilter(values[SURVEY_SUBMISSION_REPORTING_TO_KEY]),
  };
}
